function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
});

function SvgIconFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -4 32 32"
  }, props), _ref);
}

export default __webpack_public_path__ + "cb3da68ff8208da8a02d09cdee62b579.svg";
export { SvgIconFolder as ReactComponent };